var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"300","autoplay":"","id":"iframe","allowfullscreen":"true","webkitallowfullscreen":"true","mozallowfullscreen":"true"}},[_vm._v(" 暂无视频 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }